import { useChatRoom } from '@commenda/api';
import { ChatRoomModel } from '@commenda/utils';
import { Button, Icons } from '@commenda/kakashi';

const AgentChatRoomTrigger = ({
  chatRoomId,
  onClick,
  userId: _userId,
}: {
  chatRoomId: string;
  onClick: () => void;
  userId: string;
}) => {
  const { data: chatRoomResponse } = useChatRoom({ chatRoomId });

  const room = chatRoomResponse?.chatRoom;
  const totalUnread = room != null ? ChatRoomModel.getTotalUnread(room) : 0;
  const hasUnread = totalUnread > 0;

  return (
    <Button size="sm" variant="tertiary" onClick={onClick}>
      <div className="relative">
        <Icons.Inbox01 className="size-5" />
        {hasUnread && (
          <div
            className="absolute top-[-2px] right-[-2px] w-3 h-3 bg-blue-500 rounded-full border-2 border-white"
            aria-label={`${totalUnread} unread messages`}
          />
        )}
      </div>
      <span>Inbox</span>
    </Button>
  );
};

export { AgentChatRoomTrigger };
